import React, { useEffect, useState } from "react";
import client from "../../client/Client";
import HeaderBanner from "../ui/HeaderBanner";

interface myData {
  CallForWorkshopsEmail: string,
  CallForWorkshops: {
    asset: {
      _ref: string;
    };
  }
}

const WorkshopsAndTutorial = () => {
  const [data, setData] = useState<myData>();
  const [date, setDate] = useState<string>("");

  useEffect(() => {
    client
      .fetch('*[_type == "Programs"]')
      .then((result) => {
        setData(result[0]);
        setDate(result[0].CallForWorkshopsDL);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getTemplateUrl = () => {
    if (!data?.CallForWorkshops?.asset?._ref) return '';
    return `https://cdn.sanity.io/files/79vgbaej/production/${data.CallForWorkshops.asset._ref.slice(5, -4)}.${data.CallForWorkshops.asset._ref.slice(-3)}`;
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div
        className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1"
        aria-hidden="true"
      >
        <svg
          width="1360"
          height="578"
          viewBox="0 0 1360 578"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="50%"
              y2="100%"
              id="illustration-01"
            >
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>
      
      <HeaderBanner title="Workshop & Tutorial" />
      
      <div className="text-left space-y-8 pt-12">
        {/* Main Title Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-800 mb-4">
            Call for Workshop & Tutorial Sessions
          </h1>
          <p className="text-gray-700 text-lg">
            SSD encourages the organization of workshops and tutorials focusing on the latest trends in electrical engineering and information technology.
          </p>
        </div>

        {/* Special Sessions Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            SSD Call for Special Sessions
          </h2>
          {data?.CallForWorkshopsEmail && (
            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                SSD encourages scientists/industrials from the world over who are working on the conference's topics to organize workshops and/or tutorials. The workshop/tutorial should focus mainly on the latest trends in electrical engineering and information technology.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Scientific and Industrial Workshop proposals must be submitted using the template below and sent to the workshop, tutorial, and special session chairs via email.
              </p>
              
              {/* Template Download Button */}
              <div className="flex justify-center mt-6">
                <a
                  href={getTemplateUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-902 hover:text-white bg-white border-2 border-blue-901 rounded-lg px-6 py-3 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-blue-901 group text-center inline-block"
                >
                  <span className=" font-semibold text-lg">
                    Download Template
                  </span>
                </a>
              </div>

              {/* Email Contact */}
              <div className="bg-white p-4 rounded-lg border border-gray-200 mt-4">
                <p className="text-gray-700 text-center">
                  Submit proposals to:{" "}
                  <a 
                    className=" text-blue-901 hover:text-blue-800 font-semibold underline" 
                    href={`mailto:${data.CallForWorkshopsEmail}`}
                  >
                    {data.CallForWorkshopsEmail}
                  </a>
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Important Dates Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Important Dates
          </h2>
          
            <p className="text-gray-700 text-lg">
              Deadline for submission of workshop/tutorial proposals:{" "}
              <span className="text-red-600 font-semibold">{date}</span>
            </p>
        </div>

        {/* Additional Information Section */}
        <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-red-600 mb-2">
            Need More Information?
          </h3>
          <p className="text-gray-700">
            For any questions regarding workshops and tutorials, please contact:{" "}
            <a 
              className="text-red-600 hover:text-red-800 font-medium underline" 
              href={`mailto:${data?.CallForWorkshopsEmail}`}
            >
              {data?.CallForWorkshopsEmail}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WorkshopsAndTutorial;